"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertiseEntryCopy = exports.ExpertiseEntryHeader = exports.ExpertiseEntryContainer = exports.ExpertiseSectionTitle = exports.ExpertiseSectionContainer = exports.ExpertiseTitle = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ExpertiseTitle = styled_1.default.h2 `
  border: none;
  margin: 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.ExpertiseSectionContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.ExpertiseSectionTitle = styled_1.default.h3 `
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
`;
exports.ExpertiseEntryContainer = styled_1.default.div `
  padding-bottom: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};

  &:last-child {
    margin-bottom: 0;
  }
`;
exports.ExpertiseEntryHeader = styled_1.default.h4 `
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  color: black;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
exports.ExpertiseEntryCopy = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
`;
//# sourceMappingURL=styles.js.map